<template>
  <div class="premium-phone-toggle position-relative">
    <div v-if="locked" class="premium-banderole">
      <span class="premium-banderole__label">premium</span>
    </div>

    <Field
      v-slot="{ value, handleChange }"
      :name="name"
      type="checkbox"
      :value="true"
      :unchecked-value="false"
    >
      <label class="premium-phone-toggle__control" :for="inputId">
        <ToggleSwitch
          :input-id="inputId"
          :model-value="!!value"
          @update:model-value="handleChange"
        />
        <span>Telefonnummer auf der Detailseite anzeigen</span>
      </label>
    </Field>

    <p class="premium-phone-toggle__number text-muted small mb-0">
      <template v-if="displayPhoneNumber">
        Ausgegeben wird: <strong>{{ displayPhoneNumber }}</strong>
      </template>
      <template v-else>
        Keine Telefonnummer hinterlegt.
      </template>
      <button
        type="button"
        class="btn btn-outline-primary btn-sm premium-phone-toggle__edit"
        @click="openAccountSettings"
      >
        <Icon icon="fa-pro-solid:pen-to-square" aria-hidden="true" />
        Ändern
      </button>
    </p>

    <PremiumFeatureHint
      class="mt-3"
      :visible="locked"
      :route-query="routeQuery"
      :hint-text="hintText"
    />
  </div>
</template>

<script>
import Swal from 'sweetalert2'
import { Field, useIsFormDirty } from 'vee-validate'
import ToggleSwitch from 'primevue/toggleswitch'
import PremiumFeatureHint from '@/components/base_type/PremiumFeatureHint.vue'
import { PREMIUM_PHONE_HINT } from '@/utils/objectFormPolicy'

export default {
  components: {
    Field,
    PremiumFeatureHint,
    ToggleSwitch,
  },
  setup() {
    return {
      isFormDirty: useIsFormDirty(),
    }
  },
  props: {
    name: {
      type: String,
      default: 'show_tel_fax',
    },
    inputId: {
      type: String,
      default: 'show-tel-fax',
    },
    locked: {
      type: Boolean,
      default: false,
    },
    phoneNumber: {
      type: String,
      default: '',
    },
    routeQuery: {
      type: Object,
      default: () => ({}),
    },
    hintText: {
      type: String,
      default: PREMIUM_PHONE_HINT,
    },
  },
  computed: {
    displayPhoneNumber() {
      return String(this.phoneNumber || '').trim()
    },
  },
  methods: {
    async openAccountSettings() {
      if (this.isFormDirty) {
        const confirmation = await Swal.fire({
          title: 'Ungespeicherte Änderungen',
          text: 'Beim Wechsel zu den Account-Einstellungen gehen Ihre ungespeicherten Änderungen an diesem Eintrag verloren.',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Änderungen verwerfen',
          cancelButtonText: 'Hier bleiben',
          confirmButtonColor: '#c95f5f',
          focusCancel: true,
        })

        if (!confirmation.isConfirmed) {
          return
        }
      }

      await this.$router.push({ name: 'account.settings' })
    },
  },
}
</script>

<style scoped>
.premium-phone-toggle {
  margin-top: 1rem;
  margin-bottom: 1rem;
}

.premium-phone-toggle__control {
  display: inline-flex;
  gap: 0.75rem;
  align-items: center;
  margin-bottom: 0.35rem;
  font-weight: 600;
}

.premium-phone-toggle__number strong {
  color: #1d2d44;
}

.premium-phone-toggle__edit {
  display: inline-flex;
  gap: 0.35rem;
  align-items: center;
  margin-left: 0.65rem;
  padding: 0.2rem 0.55rem;
  vertical-align: middle;
  font-weight: 600;
}
</style>
